import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  InputSignalWithTransform,
  booleanAttribute,
  input
} from '@angular/core';

import { BooleanInputType } from '@modules/core/types/boolean-input.type';

@Component({
  selector: 'app-mission-acceptance-form-row',
  standalone: true,
  templateUrl: './mission-acceptance-form-row.component.html',
  styleUrl: './mission-acceptance-form-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MissionAcceptanceFormRowComponent {
  readonly label: InputSignal<string> = input.required<string>();
  readonly required: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(false, {
    transform: booleanAttribute
  });
}
